import { mapState } from 'vuex';

import styled from 'vue-styled-components';
import { GRAY } from '@styles/common.styled';

import InstagramIcon from '@svgIcons/dashboard/instagram.svg';
import AppleIcon from '@svgIcons/apple_round_color.svg';
import AdrielIcon from '@svgIcons/adriel_color.svg';
import YoutubeIcon from '@svgIcons/youtube_color.svg';
import GooglePlayIcon from '@svgIcons/googleplay.svg';
import AmazonIcon from '@svgIcons/amazon_color.svg';
import LinkedinIcon from '@svgIcons/channel_linkedin.svg';
import TwitterIcon from '@svgIcons/channel_twitter.svg';

import FacebookIconColor from '@svgIcons/dashboard/facebook_color.svg';
import GoogleIconColor from '@svgIcons/dashboard/google_color.svg';
import KakaoKeywordsAds from '@svgIcons/dashboard/kakao_keywords_ads_color.svg';
import YelpIconColor from '@svgIcons/dashboard/yelp_color.svg';
import MicrosoftIconColor from '@svgIcons/dashboard/microsoft_color.svg';
import NaverIconColor from '@svgIcons/naver.svg';
import TiktokIcon from '@svgIcons/tiktok_color.svg';
import RawIcon from '@svgIcons/raw_data.svg';
import GoogleMultiIcon from '@svgIcons/google_multi.svg';
import FbMultiIcon from '@svgIcons/channel_facebook_instagram.svg';
import SnapchatIcon from '@svgIcons/snapchat_color.svg';
import CriteoIcon from '@svgIcons/criteo_color.svg';
import AppsFlyerIcon from '@svgIcons/appsFlyer_color.svg';
import YahooIcon from '@svgIcons/yahoo_color.svg';
import GaIcon from '@svgIcons/channel_analytics.svg';
import BranchIcon from '@svgIcons/branch_color.svg';
import PinterestIcon from '@svgIcons/channel_pinterest_color.svg';
import GoogleSpreadIcon from '@svgIcons/channel_google_sheets.svg';
import AppStoreConnectIcon from '@svgIcons/apple_color.svg';
import PlayStoreIcon from '@svgIcons/channel_google_play_color.svg';
import RedditIcon from '@svgIcons/reddit_color.svg';
import NaverGFAIcon from '@svgIcons/naverGFA_color.svg';
import MailchimpIcon from '@svgIcons/mailchimp_color.svg';
import UnityIcon from '@svgIcons/unity_color.svg';
import InstacartIcon from '@svgIcons/instacart.svg';
import MessengerIcon from '@svgIcons/channel_messenger.svg';
import MetaIcon from '@svgIcons/channel_meta.svg';
import LogicadIcon from '@svgIcons/icon_logicad.svg';
import MarketingIcon from '@svgIcons/groupId_marketing.svg';
import OrganicIcon from '@svgIcons/groupId_organic.svg';
import { refineChannel } from '@/utils/dashboard';

const CHANNEL_UNIQUE_ICON_MAP = {
    kakaoKeywordsAds: 'kakao',
};

const CUSTOM_CHANNEL_KEY_MAP = {
    ['Viant Technology']: 'Viant',
};

// PLACEHOLDER for icon

export default {
    data() {
        return {
            CHANNEL_ICONS: Object.freeze({
                apple: <AppleIcon v-view-box class="apple" key="apple" />,
                google_video: (
                    <YoutubeIcon v-view-box class="youtube" key="youtube" />
                ),
                youtube: (
                    <YoutubeIcon v-view-box class="youtube" key="youtube" />
                ),
                google: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_unknown: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_search: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_display: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_shopping: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_universal_appstore: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_universal_playstore: (
                    <GooglePlayIcon
                        v-view-box
                        class="google"
                        key="google-play"
                    />
                ),
                google_local_services: (
                    <GoogleIconColor
                        v-view-box
                        class="google"
                        key="google_local_services"
                    />
                ),
                kakao: (
                    <KakaoKeywordsAds v-view-box class="kakao" key="kakao" />
                ),
                kakaoKeywordsAds: (
                    <KakaoKeywordsAds
                        v-view-box
                        class="kakaoKeywordsAds"
                        key="kakao"
                    />
                ),
                instagram: (
                    <InstagramIcon
                        v-view-box
                        class="instagram"
                        key="instagram"
                    />
                ),
                microsoft: (
                    <MicrosoftIconColor
                        v-view-box
                        class="microsoft bing"
                        key="microsoft"
                    />
                ),
                naver: <NaverIconColor v-view-box class="naver" key="naver" />,
                yelp: <YelpIconColor v-view-box class="yelp" key="yelp" />,
                adriel: <AdrielIcon v-view-box class="adriel" key="adriel" />,
                facebook: (
                    <FacebookIconColor
                        v-view-box
                        class="facebook"
                        key="facebook"
                    />
                ),
                audience_network: (
                    <MetaIcon v-view-box class="meta" key="meta" />
                ),
                messenger: (
                    <MessengerIcon
                        v-view-box
                        class="messenger"
                        key="messenger"
                    />
                ),
                marketing: (
                    <MarketingIcon
                        v-view-box
                        class="marketing"
                        key="marketing"
                    />
                ),
                organic: (
                    <OrganicIcon v-view-box class="organic" key="organic" />
                ),
                amazon: <AmazonIcon v-view-box class="amazon" key="amazon" />,
                linkedin: (
                    <LinkedinIcon v-view-box class="linkedin" key="linkedin" />
                ),
                tiktok: <TiktokIcon v-view-box class="linkedin" key="tiktok" />,
                twitter: (
                    <TwitterIcon v-view-box class="twitter" key="twitter" />
                ),
                externalFiles: <RawIcon v-view-box class="raw" key="raw" />,
                googleMulti: (
                    <GoogleMultiIcon
                        v-view-box
                        class="googleMulti"
                        key="googleMulti"
                    />
                ),
                google_multi_channel: (
                    <GoogleMultiIcon
                        v-view-box
                        class="googleMulti"
                        key="googleMulti"
                    />
                ),
                fbMulti: (
                    <FbMultiIcon v-view-box class="fbMulti" key="fbMulti" />
                ),
                google_smart: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_discovery: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_demandgen: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_demand_gen: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_performance_max: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_local: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                google_travel: (
                    <GoogleIconColor v-view-box class="google" key="google" />
                ),
                snapchat: (
                    <SnapchatIcon v-view-box class="snapchat" key="snapchat" />
                ),
                criteo: <CriteoIcon v-view-box class="criteo" key="criteo" />,
                appsFlyer: (
                    <AppsFlyerIcon
                        v-view-box
                        class="appsFlyer"
                        key="appsFlyer"
                    />
                ),
                yahoo: <YahooIcon v-view-box class="yahoo" key="yahoo" />,
                facebook_undetermined: (
                    <FbMultiIcon v-view-box class="fbMulti" key="fbMulti" />
                ),
                googleAnalytics: (
                    <GaIcon
                        v-view-box
                        class="googleAnalytics"
                        key="googleAnalytics"
                    />
                ),
                googleAnalytics4: (
                    <GaIcon
                        v-view-box
                        class="googleAnalytics"
                        key="googleAnalytics"
                    />
                ),
                ga: (
                    <GaIcon
                        v-view-box
                        class="googleAnalytics"
                        key="googleAnalytics"
                    />
                ),
                branch: <BranchIcon v-view-box class="branch" key="branch" />,
                pinterest: (
                    <PinterestIcon
                        v-view-box
                        class="pinterest"
                        key="pinterest"
                    />
                ),
                googleSpreadSheet: (
                    <GoogleSpreadIcon
                        v-view-box
                        class="googleSpread"
                        key="googleSpread"
                    />
                ),
                appStoreConnect: (
                    <AppStoreConnectIcon
                        v-view-box
                        class="appStoreConnect"
                        key="appStoreConnect"
                    />
                ),
                playStore: (
                    <PlayStoreIcon
                        v-view-box
                        class="playStore"
                        key="playStore"
                    />
                ),
                reddit: <RedditIcon v-view-box class="reddit" key="reddit" />,
                naverGFA: (
                    <NaverGFAIcon v-view-box class="naverGFA" key="naverGFA" />
                ),
                mailchimp: (
                    <MailchimpIcon
                        v-view-box
                        class="mailchimp"
                        key="mailchimp"
                    />
                ),
                mailchimpAdAccount: (
                    <MailchimpIcon
                        v-view-box
                        class="mailchimp"
                        key="mailchimp"
                    />
                ),
                unityAds: <UnityIcon v-view-box class="unity" key="unity" />,
                instacart: (
                    <InstacartIcon
                        v-view-box
                        class="instacart"
                        key="instacart"
                    />
                ),
                logicad: (
                    <LogicadIcon v-view-box class="logicad" key="logicad" />
                ),
                // PLACEHOLDER for data
            }),
        };
    },
    computed: {
        ...mapState('newDashboard', { mixinAdAccounts: 'tableAdAccounts' }),
        externalIconMap() {
            const { mixinAdAccounts = [] } = this;

            const internalMap = R.compose(
                R.pluck('logo'),
                R.indexBy((account) => {
                    const { displayChannelName } = account;

                    const refinedChannel = refineChannel(account);

                    return (
                        CUSTOM_CHANNEL_KEY_MAP[displayChannelName] ||
                        refinedChannel
                    );
                }),
                R.filter(R.propSatisfies(R.identity, 'logo'))
            )(mixinAdAccounts);

            return internalMap;
        },
        channelKeys() {
            return Object.keys(this.CHANNEL_ICONS);
        },
    },
    methods: {
        channelIconsFromArray(arr) {
            return R.map(this.channelIconWithAdverity, arr);
        },
        uniqChannelIcons: R.uniqBy(R.path(['data', 'key'])),
        uniqChannelIconsFromArray(arr, ellipsis = false) {
            const { uniqChannelIcons, channelIconsFromArray } = this;
            const listOfChannels = R.compose(
                uniqChannelIcons,
                channelIconsFromArray
            )(arr);

            if (ellipsis) {
                const dots = (
                    <DotWrapper>{R.repeat(<span>&#183;</span>, 3)}</DotWrapper>
                );

                return listOfChannels.length > 2
                    ? [...R.take(2, listOfChannels), dots]
                    : [];
            } else {
                return listOfChannels;
            }
        },
        renderIconByChannel(name) {
            return this.CHANNEL_ICONS[name];
        },
        channelIconWithAdverity(name) {
            if (!name) return;

            const lowered = R.toLower(name);

            const adveritySrc = this.externalIconMap[name];
            if (adveritySrc) {
                return (
                    <AdverityLogo
                        class="adverity-icon"
                        src={adveritySrc}
                        key={CHANNEL_UNIQUE_ICON_MAP[name] || name}
                    />
                );
            }

            const exactIcon =
                this.CHANNEL_ICONS[name] || this.CHANNEL_ICONS[lowered];
            if (exactIcon) {
                return exactIcon;
            }

            return null;
        },
    },
};

const DotWrapper = styled.div`
    span {
        color: ${GRAY(50)};
    }
`;

const AdverityLogo = styled.img`
    width: 12px;
    height: 12px;
`;
